(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/matchen/assets/javascripts/views/draw-detail.js') >= 0) return;  svs.modules.push('/modules/matchen/assets/javascripts/views/draw-detail.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
svs.matchen.views.DrawDetail = Marionette.View.extend({
  clickClear() {
    this.couponView.clearCouponCallback();
  },
  confirmClearCoupon() {
    if (this.model.getDraw().hasSelectedOutcomes()) {
      this.showClearCouponMessage(() => {
        this.model.getXperten().fetch({
          success: () => {
            svs.components.Modal.hide();
          }
        });
      });
    } else {
      return this.couponView.refreshXperten();
    }
  },
  helpDialogMark(e) {
    if (svs.matchen.data.matchenconfig.helpTexts) {
      const dialog = new svs.components.dialog.Contextual({
        attachTo: $(e.currentTarget),
        branding: svs.components.dialog.branding.SPORT,
        message: [{
          text: svs.matchen.data.matchenconfig.helpTexts.startpage_mark.body,
          type: svs.components.dialog.message.TEXT
        }],
        title: svs.matchen.data.matchenconfig.helpTexts.startpage_mark.title,
        zIndex: 1000
      });
      svs.components.dialog.api.add(dialog);
    }
  },
  showClearCouponMessage(confirmCallback) {
    confirmCallback = confirmCallback || (() => {});
    svs.components.dialog.api.add(new svs.components.dialog.Confirm({
      branding: svs.components.dialog.branding.SPORT,
      icon: 'dustbin',
      title: 'Din kupong kommer att rensas',
      message: [{
        type: svs.components.dialog.message.TEXT,
        text: 'Vill du fortsätta ändå?'
      }],
      actions: [{
        title: 'Avbryt'
      }, {
        title: 'Fortsätt',
        callback: () => {
          svs.components.dialog.api.close();
          confirmCallback();
        }
      }]
    }));
  },
  ui: {
    clearBtn: '.js-clear-btn',
    drawArea: '.draw-area',
    helpDialogMark: '.js-help-dialog-mark',
    tabView: '.tab-view'
  },
  events: {
    'click @ui.helpDialogMark': 'helpDialogMark'
  },
  className: 'draw-detail',
  template(data) {
    return svs.matchen.templates.draw_detail(_objectSpread(_objectSpread({}, data), {}, {
      isMatchMode: false
    }));
  },
  regions: {
    contextMenu: '.matchen-context-menu',
    couponBody: '.region-draw-detail-body',
    couponHeader: '.region-draw-detail-header',
    drawSelector: '.matchen-draw-selector',
    slider: '.matchen-slider-folder'
  },
  matchOddsToogle: true,
  initialize(options) {
    this.options = options || this.options;
    this.listenTo(this.model, 'change:hasSelections', () => {
      if (this.couponView && svs.core.detect.formfactor.mobile()) {
        this.couponView.updateClearButton(this.ui.clearBtn);
      }
    });
  },
  onResizeTabView() {
    const tabView = this.getRegion('couponBody') && this.getRegion('couponBody').currentView;
    if (tabView) {
      tabView.resize();
    }
  },
  onAttach() {
    this.couponView = new svs.matchen.views.Coupon({
      model: this.model
    });
    this.showChildView('couponBody', this.couponView);
    this.showDrawSelector();
    this.contextMenu = new svs.matchen.views.ContextMenu({
      model: this.model
    });
    this.showChildView('contextMenu', this.contextMenu);
    this.showChildView('couponHeader', new svs.matchen.views.CouponHeader({
      hasMatchInfoTabs: () => true,
      model: this.model.get('draw')
    }));
    if (svs.core.detect.formfactor.mobile()) {
      svs.core.template.updateConfig({
        title: {
          row1: {
            alt: 'Matchen',
            brand: 'matchen'
          }
        }
      });
    }
    svs.components.navigation.setHamburgerIcon('menu');
    svs.components.navigation.restoreHamburgerCallback();
    this.listenTo(this.tabView, 'onChange', this.onResizeTabView);
    if (svs.core.detect.formfactor.desktop()) {
      const multiSwiperOptions = {
        scrollerOptions: [{
          nodeId: 'draw-area',
          toSubtract: ['#top-content', '#drawselector', '#campaign-flerp']
        }]
      };
      this.multiSwiper = new svs.components.MultiSwiper(multiSwiperOptions);
      this.multiSwiper.init();
      this.firstLoad();
    }
    svs.core.data.title = {
      eventDescription: this.model.get('draw').get('eventDescription')
    };
    this.renderBetslip();
    svs.matchen.views.betslip.initRelativeBetslip();
    setTimeout(() => {
      svs.matchen.views.betslip.betslipStickyBehaviour();
    }, 300);
  },
  renderBetslip() {
    const self = this;
    $('#betslip-wrapper').html(svs.matchen.views.betslip.render().el);
    svs.matchen.views.betslip.getRegion('betslipFooter').show(new svs.matchen.views.BetslipFooter({
      model: this.options.model
    }));
    svs.matchen.views.betslip.getRegion('betslipPayOptions').show(new svs.matchen.views.BetslipPayOptions({
      model: this.options.model
    }));
    svs.matchen.views.betslip.getRegion('betslipPay').show(new svs.matchen.views.PayFooter({
      model: this.options.model
    }));
    this.triggerScroll = function () {
      $('.js-swiper-container').has('#coupon').trigger('scroll');
      setTimeout(() => {
        svs.matchen.views.betslip.setWidth();
      }, 300);
    };
    this.triggerScroll = this.triggerScroll.bind(this);
    this.cancelDebounce = false;
    this.runBetslip = _.debounce(() => {
      if (!self.cancelDebounce) {
        svs.matchen.views.betslip.initRelativeBetslip();
        svs.matchen.views.betslip.betslipStickyBehaviour();
        self.triggerScroll();
      }
    }, 500);
    if (svs.core.detect.formfactor.desktop()) {
      $(window).on('resize', this.runBetslip);
    }
    this.listenTo(this.model.get('xperten'), 'change', this.runBetslip);
    this.listenTo(svs.matchen.tipsInfo, 'change', this.runBetslip);
  },
  onDestroy() {
    this.cancelDebounce = true;
    $(window).off('resize', this.runBetslip);
    this.stopListening(this.model.get('xperten'), 'change', this.runBetslip);
    this.stopListening(svs.matchen.tipsInfo, 'change', this.runBetslip);
    if (this.tabs) {
      this.tabs = null;
      delete this.tabs;
    }
    if (this.$el) {
      this.$el.empty();
    }
    $('#matchen-odds-dimmer').removeClass('matchen-odds-dimmer-visible');
  },
  loadMatchOdds() {
    this.odds = new svs.matchen.views.MatchenOdds({
      model: this.model
    });
    this.showChildView('slider', this.odds);
  },
  firstLoad() {
    this.loadMatchOdds();
  },
  destroyTabs() {
    _.each(this.tabs, function (tab) {
      if (tab && !tab.isDestroyed && !tab.isDestroyed()) {
        tab.destroy();
      }
      if (tab.caption == 'Kupong') {
        this.stopListening(tab);
      }
    });
  },
  showDrawSelector() {
    const drawselectorOptions = {
      branding: 'matchen',
      callback: drawNum => {
        const draw = _.findWhere(svs.matchen.data.draws, {
          drawNumber: Number(drawNum)
        });
        const eventDescription = svs.utils.url.encode(draw.eventDescription);
        const description = svs.utils.url.encode(draw.description);
        Backbone.history.navigate("/spela/".concat(drawNum, "-").concat(eventDescription, "-").concat(description), {
          replace: true,
          trigger: true
        });
      },
      currentDraw: this.model.get('draw').get('drawNumber'),
      draws: svs.matchen.collections.draws.models,
      swiperUpdateFunction: () => {
        if (this.multiSwiper) {
          this.multiSwiper.updateSize();
        }
      }
    };
    const drawSelector = new svs.sport.drawselector.views.Drawselector(drawselectorOptions);
    this.showChildView('drawSelector', drawSelector);
  }
});

 })(window);